
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';

export interface StartExperienceDatesBackfillRequest {
    fromYear?: number;
    toYear?: number;
}

/**
 * 
 */
export class ExperienceDatesBackfillApi extends runtime.BaseAPI {

    /**
     * Asynchronous and idempotent: only the experiences with no local date yet are filled. Restrict the run to the profiles created between the two years, both included. 
     * Start the one-off backfill of the timezone-free experience dates
          */
    async startExperienceDatesBackfillRaw(requestParameters: StartExperienceDatesBackfillRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['fromYear'] != null) {
            queryParameters['fromYear'] = requestParameters['fromYear'];
        }

        if (requestParameters['toYear'] != null) {
            queryParameters['toYear'] = requestParameters['toYear'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/profile/api/admin/experience-dates/backfill`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Asynchronous and idempotent: only the experiences with no local date yet are filled. Restrict the run to the profiles created between the two years, both included. 
     * Start the one-off backfill of the timezone-free experience dates
          */
    async startExperienceDatesBackfill(requestParameters: StartExperienceDatesBackfillRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.startExperienceDatesBackfillRaw(requestParameters, initOverrides);
    }

}
